"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.error.profession_required': '请在继续之前选择一个职业',
    'onboarding.error.profession_select_first': '请先选择一个职业',
    'onboarding.error.avatar_name_required': '头像名称是必需的',
    'onboarding.error.avatar_name_provide': '请提供头像名称',
    'onboarding.error.answer_required': '答案是必需的',
    'onboarding.error.complete_required_step': '请完成必需的步骤',
    'onboarding.error.complete_step': '请完成步骤',
    'onboarding.error.before_finishing': '在完成之前',
    'onboarding.error.professions_load_failed': '加载职业失败',
    'onboarding.error.professions_load_general': '加载职业时发生一般错误',
    'onboarding.error.steps_load_failed': '加载步骤失败',
    'onboarding.error.steps_load_general': '加载步骤时发生一般错误',
    'onboarding.error.questions_load_failed': '加载问题失败',
    'onboarding.error.questions_load_general': '加载问题时发生一般错误',
    'onboarding.error.load_failed': '加载入职数据失败',
    'onboarding.error.load_general': '加载入职时发生一般错误',
    'onboarding.error.save_failed': '保存入职失败',
    'onboarding.error.save_general': '保存入职时发生一般错误',
};
